import React, { Component, Fragment } from 'react';
import queryString from 'query-string';
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as CampaignActions } from 'store/ducks/campaigns';

import { Access } from 'common';
import { Page, Panel, Loading, Pagination, Breadcrumbs, Icon } from 'components';

class List extends Component {
  state = {
    breadcrumbs: [
      { name: 'Home', to: '/' },
      { name: 'Pontos', to: '/points' },
      { name: 'Campanhas de Pontos', to: '' },
    ],
  };

  componentDidMount() {
    const { location, getCampaignsRequest } = this.props;
    const params = queryString.parse(location.search);
    const page = params.page ? params.page : 1;

    getCampaignsRequest(page);
  }

  componentDidUpdate(oldProps) {
    const { location, getCampaignsRequest } = this.props;

    if (queryString.parse(oldProps.location.search).page !== queryString.parse(location.search).page) {
      getCampaignsRequest(queryString.parse(location.search).page);
    }
  }

  handleDelete = id => {
    this.props.deleteCampaignRequest(id);
  };

  render() {
    const { breadcrumbs } = this.state;
    const { campaigns } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Page.Title>Campanha de Pontos</Page.Title>

        <Panel className="panel-list">
          {!campaigns.data.length && campaigns.loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {campaigns.loading && <Loading type="table" size="x-large" />}

              <table className="contact-table table table-curved table-striped">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>descrição</th>
                    <th>loja</th>
                    <th>período</th>
                    <th>situação</th>
                    <th className="text-right">ação</th>
                  </tr>
                </thead>
                <tbody>
                  {!campaigns.data.length && (
                    <tr>
                      <td colSpan="6" className="text-center">
                        Nenhum registro encontrado.
                      </td>
                    </tr>
                  )}

                  {campaigns.data.map((campaign, index) => (
                    <tr key={campaign.id}>
                      <td>{campaign.attributes.external_id}</td>
                      <td>{campaign.attributes.name}</td>
                      <td>{campaign.attributes.type_campaign}</td>
                      <td>{campaign.attributes.description}</td>
                      <td className={campaign.attributes.score ? 'label-active' : 'label-inactive'}>
                        {campaign.attributes.score ? 'Sim' : 'Não'}
                      </td>
                      <td className="text-right">
                        {Access.hasPermissions('edit-campaign') && (
                          <Link to={`/points/campaigns/${campaign.id}/edit`} className="button-icon">
                            <Icon name="pencil" />
                          </Link>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <th colSpan="6" />
                  </tr>
                </tfoot>
              </table>

              <Pagination current={campaigns.page} total={campaigns.totals} {...this.props} />

              {Access.hasPermissions('edit-campaigns') && (
                <Link className="button-add" to="/points/campaigns/create">
                  Adicionar Campanha
                </Link>
              )}
            </Fragment>
          )}
        </Panel>
      </Page>
    );
  }
}

const mapState = state => ({
  campaigns: state.campaigns,
});

const mapActions = dispatch => bindActionCreators(CampaignActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(List);
